import HTMLReactParser from "html-react-parser";
import { useEffect } from "react";

const GlobalNotifications = ({ notifications }) => {
  useEffect(() => {
    setTimeout(() => {
      if (window.SBYAdminNotifications) {
        window.SBYAdminNotifications.init();
        window.SBYAdminNotifications.jqueryInit(window.jQuery);
      }
    }, 0);
  }, []);

  return <div>{HTMLReactParser(notifications)}</div>;
};

export default GlobalNotifications;
